import React, { lazy, Suspense } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'app/store'
import Progress from 'core/components/progress/Progress'
import SearchBar from 'core/components/SearchBar'
import { pathStrOr } from 'utils/fp'
import { memoize } from 'utils/misc'

const JsonView = lazy(() => import('react-json-view'))

interface Props {
  store: RootState
}

// @ts-ignore
@connect((store) => ({ store }))
class StoreViewer extends React.PureComponent<Props> {
  state = { searchTerm: '' }
  handleSearchChange = (searchTerm) => this.setState({ searchTerm })
  moizedSearch = memoize((searchTermPath) => {
    const { store } = this.props
    return pathStrOr(store, searchTermPath, store)
  })
  render() {
    const { store } = this.props
    const { searchTerm } = this.state
    const searchedContext = this.moizedSearch(searchTerm)
    return (
      <div>
        <SearchBar onSearchChange={this.handleSearchChange} searchTerm={searchTerm} />
        <hr />
        <Suspense fallback={<Progress loading />}>
          <JsonView src={searchedContext} collapsed={1} enableClipboard />
        </Suspense>
      </div>
    )
  }
}

export default StoreViewer
